import { render, staticRenderFns } from "./header.vue?vue&type=template&id=1949505b"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\pj\\Platform\\xrcNet\\xrcNet_plat_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1949505b')) {
      api.createRecord('1949505b', component.options)
    } else {
      api.reload('1949505b', component.options)
    }
    module.hot.accept("./header.vue?vue&type=template&id=1949505b", function () {
      api.rerender('1949505b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/component/header.vue"
export default component.exports